import { render, staticRenderFns } from "./autoCall.vue?vue&type=template&id=258ca954&scoped=true&"
import script from "./autoCall.vue?vue&type=script&lang=js&"
export * from "./autoCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ca954",
  null
  
)

export default component.exports